import { Typography } from "@mui/material";
import MetadataContainer from "./MetadataContainer";


const MetadataNotFound = () => (
    <MetadataContainer>
        <Typography 
            sx={{textAlign: "center"}} 
            variant='subtitle1'>
                No metadata found.
        </Typography>
    </MetadataContainer>
);

export default MetadataNotFound;